export default __webpack_public_path__ + "static/media/Growyx.52317e2a.ico";